<template>  
<div> <!-- root element start -->
    <div  class="row" v-if="dataComp == 0">
      <div class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>
    <div v-if="dataComp == 1" class="row">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-header bg-transparent border-0 pb-1">
            <div class="row">
              <div class="col-12"><span class="h5">{{ data.f_name }} {{ data.l_name }}</span></div>
            </div>
            <div class="row">
              <div class="col-12 text-right"><a href="#" @click="editContact(data.id)"><small>Edit Contact</small></a></div>
            </div>

          </div>
          <div class="card-body pb-1">
              <div class="row">
                <div class="col-12">
                  <span class="text-muted">Since:</span><span> {{ data.created_at | moment("MM-DD-YYYY") }}</span>
                </div>
                
                <div class="col-12">
                  <span class="text-muted">Creator:</span><span> {{ data.creatorName }}</span>
                </div>
                <div class="col-12">
                  <hr class="py-1">
                </div>
              </div>
          </div>

          <div class="card-body pb-1 pt-1">
              <div class="row">
                <div class="col-12">
                  <span class="text-muted">Primary Email:</span><span> {{ data.pri_email }}</span>
                </div>
                
                <div class="col-12">
                  <span class="text-muted">Primary Phone:</span>
                  <span v-if="data.pri_phone != null"> {{ data.pri_phone}}</span>
                  <span v-if="data.pri_phone == null"> Unassigned</span>
                </div>
                <div class="col-12">
                  <hr class="py-1">
                </div>
              </div>
          </div>

        </div>
      </div>
    </div>

    <hr class="bg-dark my-2">
</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/contact-main-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 



    }
  },
  computed: {
    data () { return this.$store.state.contactDetails },
    dataComp () { return this.$store.state.contactDetailsComp },
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    editAddress(x) {
      var _this = this;
      _this.$emit('onSecComplete', ['launchEditAddress', x])
    },
    editContact(x) {
      var _this = this;
      _this.$emit('onSecComplete', ['launchEditContact', x])
    }
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
